import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom';

const PublicBreadCrumbs = ({ trails, location }) => (
  <div className="bread-crumbs text-xs lg:text-lg flex items-center justify-start lato-reg text-primary-orange">
    <span className="lg:block">
      {trails.map((trail, key) => (
        <Fragment key={key}>
          <a href={trail.url} className={`${location.pathname === trail.url ? 'text-primary-lightgray' : 'text-primary-orange'}`}>
            {trail.title}
          </a>
          {trails.length - 1 > key && <i className="fa fa-angle-double-right mx-2" aria-hidden="true"></i>}
        </Fragment>
      ))}
    </span>
  </div>
)

PublicBreadCrumbs.propTypes = {
  trails: PropTypes.arrayOf(PropTypes.object),
  location: PropTypes.object.isRequired,
}

export default withRouter(PublicBreadCrumbs)
